// @mui
import { Typography, Stack } from '@mui/material';
// components
import Logo from '../../components/logo';
import Image from '../../components/image';
//
import { StyledTypography } from 'src/pages/components/RegisterSteps/Register';
import { StyledRoot, StyledSectionBg, StyledSection, StyledContent } from './styles';

type Props = {
  title?: string;
  illustration?: string;
  children: React.ReactNode;
};

export default function LoginLayout({ children, illustration, title }: Props) {
  return (
    <StyledRoot>
      <Logo
        isMain
        sx={{
          zIndex: 9,
          position: 'absolute',
          mt: { xs: 1.5, md: 5 },
          ml: { xs: 2, md: 5 },
          width: 64,
          height: 64,
          borderRadius: 50,
        }}
      />

      <StyledSection>
        <StyledTypography sx={{
          fontSize: 30,
          mb: 5, maxWidth: 720, textAlign: 'center', background: 'linear-gradient(to right, #1b1b1b 0%, #8940b5 100%)', WebkitBackgroundClip: "text",
          WebkitTextFillColor: "transparent"
        }}>
          {title || 'Welcome to LEV Advertising Dashboard'}
        </StyledTypography>

        <Image
          disabledEffect
          visibleByDefault
          alt="auth"
          src={illustration || '/assets/background/advertisment.png'}
          sx={{ maxWidth: 720 }}
        />

        <StyledSectionBg />
      </StyledSection>

      <StyledContent>
        <Stack sx={{ width: 1 }}> {children} </Stack>
      </StyledContent>
    </StyledRoot>
  );
}
